import { useState } from 'react';

interface FAQItem {
  id: number;
  category: string;
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    id: 1,
    category: '견적·비용',
    question: '진주 벌초 서비스 비용은 어떻게 산출되나요?',
    answer:
      'GPS 기반 정밀 면적 측정과 경사도, 접근성, 잡초 밀도, 이동 거리 등 21개 현장 요인을 종합 분석해 견적을 산출합니다. 기본 산소 벌초는 100,000원부터 시작하며, 4기 이상 동일 구역 묶음 작업 시 300,000원 정액 할인 패키지를 적용해 드립니다. 무료 견적 신청을 통해 정확한 금액을 먼저 확인하실 수 있습니다.',
  },
  {
    id: 2,
    category: '견적·비용',
    question: '전원주택 정원관리 연간 구독 비용은 어떻게 되나요?',
    answer:
      '스탠다드 플랜은 연 120만 원부터 시작하며 분기별 정기 방문(연 4회), 전지·예초·주택 노후 점검, 포토 리포트 전송이 포함됩니다. 프리미엄 플랜은 연 240만 원부터로 격월 정밀 관리(연 6회), 병해충 방제, 시설물 소수리, 긴급 출동 서비스, 드론 촬영 리포트까지 제공됩니다. 비구독 시 연간 예상 비용 380만 원 대비 최대 68% 절감 효과가 있습니다.',
  },
  {
    id: 3,
    category: '서비스 지역',
    question: '서비스 가능 지역은 어디까지인가요?',
    answer:
      '경남 진주시 전 지역을 기본 서비스 권역으로 운영합니다. 특히 문산읍, 금산면, 지수면, 집현면, 대곡면 등 진주 외곽 전원주택 밀집 지역과 선산이 많은 농촌 지역을 중점 커버합니다. 인근 사천시, 고성군, 함안군 등도 현장 여건에 따라 출장 가능하니 별도 문의 부탁드립니다.',
  },
  {
    id: 4,
    category: '작업 확인',
    question: '작업 후 결과를 어떻게 확인할 수 있나요?',
    answer:
      '작업 완료 즉시 드론으로 촬영한 전·후 비교 사진과 전문가 소견서를 SMS로 전송해 드립니다. 드론 촬영 보고서에는 작업 면적, 제거된 식생 유형, 시설물 상태 점검 결과가 포함되며, 선산의 경우 봉분·비석·석축 상태까지 기록됩니다. 원격으로도 언제 어디서나 작업 결과를 확인하실 수 있습니다.',
  },
  {
    id: 5,
    category: '작업 확인',
    question: '작업 일정은 어떻게 조율하나요?',
    answer:
      '견적 확정 후 고객이 희망하는 날짜에 맞춰 일정을 조율합니다. 성묘 전날·추석 전 벌초의 경우 최소 2주 전 예약을 권장합니다. 작업 당일 기상 악화(폭우·태풍 경보) 시 자동 일정 재조율 알림 SMS를 발송하며, 완료 후 결과 보고까지 같은 날 처리됩니다.',
  },
  {
    id: 6,
    category: '기술·장비',
    question: '10년 위성 데이터 분석이란 무엇인가요?',
    answer:
      '10년치 위성 이미지 데이터를 분석해 해당 부지의 식생 변화, 침식 위험 구간, 계절별 잡초 성장 패턴을 파악합니다. 이 데이터를 토대로 GPS 측정 전 현장 예비 분석이 가능해 초기 견적 정확도가 높아지고, 향후 관리 계획도 선제적으로 수립할 수 있습니다. 전원주택 정원과 산소 선산 모두에 동일하게 적용됩니다.',
  },
  {
    id: 7,
    category: '기술·장비',
    question: 'GPS 면적 측정은 얼마나 정확한가요?',
    answer:
      'RTK-GPS 정밀 측량 방식을 적용해 ±3% 이내의 오차 범위로 면적을 산출합니다. 기존 육안·줄자 측정 대비 최대 15% 오차를 줄여 과도한 견적 청구를 방지합니다. 측정 결과는 고객에게 수치로 공유되며, 견적서에 면적 근거가 명시됩니다.',
  },
  {
    id: 8,
    category: '서비스 내용',
    question: '산소 벌초 외에 묘지 보수 작업도 가능한가요?',
    answer:
      '네, 전문 석축·보수 서비스를 별도로 제공합니다. 봉분 정비, 비석 세척, 석축 유실 복원, 배수로 정비 등 고난도 공사는 평당 230,000원부터 시작합니다. 벌초 작업 중 시설물 이상이 발견되면 현장에서 즉시 사진과 함께 상태를 보고드리고, 추가 작업 진행 여부를 먼저 확인 후 시공합니다.',
  },
  {
    id: 9,
    category: '서비스 내용',
    question: '전원주택 정원관리에는 어떤 작업이 포함되나요?',
    answer:
      '정밀 예초(잔디 최적 높이 조절), 수종별 전지(수형 관리·가지치기), 잡초 제거, 병해충 방제, 시비 작업, 목재 데크 케어, 석축·법면 점검, 배수로 소통, 포토 리포트 전송까지 토탈 케어를 제공합니다. 수종 선별 및 식재 추천도 별도 상담으로 가능하며, 아름다운 정원 데이터 기반 수종 매칭 서비스도 제공합니다.',
  },
  {
    id: 10,
    category: '계약·구독',
    question: '연간 구독은 중간에 해지 가능한가요?',
    answer:
      '네, 위약금 없이 언제든 해지 신청이 가능합니다. 이미 제공된 회차의 서비스 금액을 정산 후 남은 금액을 환불해 드립니다. 일시적 사정으로 특정 회차 방문을 다음 달로 미루는 일정 조율도 가능하니 부담 없이 말씀해 주세요.',
  },
  {
    id: 11,
    category: '계약·구독',
    question: '첫 방문 전 현장 실사가 필요한가요?',
    answer:
      '위성 데이터와 고객 제공 정보로 기본 견적을 먼저 산출한 뒤, 현장 방문 실사를 통해 최종 견적을 확정합니다. 초회 현장 실사는 무료이며, 이 과정에서 GPS 면적 측정·드론 예비 촬영·토양 상태 확인이 이루어집니다. 실사 후 24시간 이내에 상세 견적서를 문자·카카오톡으로 전달해 드립니다.',
  },
];

const categories = ['전체', '견적·비용', '서비스 지역', '작업 확인', '기술·장비', '서비스 내용', '계약·구독'];

export default function FAQ() {
  const [openId, setOpenId] = useState<number | null>(null);
  const [activeCategory, setActiveCategory] = useState<string>('전체');

  const filtered =
    activeCategory === '전체'
      ? faqData
      : faqData.filter((f) => f.category === activeCategory);

  const toggle = (id: number) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section
      id="faq"
      className="relative py-16 sm:py-28 px-4 sm:px-6 overflow-hidden"
      style={{ background: 'linear-gradient(160deg, #0d1f3c 0%, #111e3a 50%, #152a52 100%)' }}
    >
      {/* subtle grid overlay */}
      <div
        className="absolute inset-0 opacity-[0.025]"
        style={{
          backgroundImage:
            'linear-gradient(0deg, transparent 49.5%, #c9a227 50%, #c9a227 50.4%, transparent 50.9%), linear-gradient(90deg, transparent 49.5%, #c9a227 50%, #c9a227 50.4%, transparent 50.9%)',
          backgroundSize: '60px 60px',
        }}
      ></div>

      <div className="max-w-4xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span className="inline-block bg-[#c9a227]/15 border border-[#c9a227]/30 text-[#c9a227] text-xs sm:text-sm font-semibold px-4 py-1.5 rounded-full mb-4 tracking-wide">
            FAQ
          </span>
          <h2 className="text-3xl sm:text-5xl font-bold text-white mb-4 leading-[1.2] tracking-tight">
            자주 묻는 <span className="text-[#c9a227]">질문</span>
          </h2>
          <p className="text-sm sm:text-lg text-white/60 leading-relaxed max-w-xl mx-auto">
            진주 벌초·전원주택 정원관리 서비스에 대해 궁금한 점을 모았습니다
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-2 mb-8 sm:mb-12">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => { setActiveCategory(cat); setOpenId(null); }}
              className={`px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-medium transition-all cursor-pointer whitespace-nowrap border ${
                activeCategory === cat
                  ? 'text-[#0d1f3c] border-[#c9a227]'
                  : 'text-white/60 border-white/15 hover:border-white/30 hover:text-white/80'
              }`}
              style={
                activeCategory === cat
                  ? { background: 'linear-gradient(135deg, #e8c84a, #b8860b)' }
                  : {}
              }
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Accordion */}
        <div className="space-y-3">
          {filtered.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className={`rounded-2xl border transition-all duration-300 overflow-hidden ${
                  isOpen
                    ? 'border-[#c9a227]/40'
                    : 'border-white/10 hover:border-white/20'
                }`}
                style={{
                  background: isOpen
                    ? 'linear-gradient(145deg, rgba(201,162,39,0.08), rgba(13,31,60,0.95))'
                    : 'rgba(21,42,82,0.5)',
                }}
              >
                {/* Question Row */}
                <button
                  onClick={() => toggle(item.id)}
                  className="w-full flex items-center gap-4 px-5 sm:px-7 py-4 sm:py-5 text-left cursor-pointer group"
                >
                  {/* Category Badge */}
                  <span className="hidden sm:inline-block flex-shrink-0 text-xs font-semibold text-[#c9a227]/80 bg-[#c9a227]/10 border border-[#c9a227]/20 px-2.5 py-1 rounded-full whitespace-nowrap">
                    {item.category}
                  </span>

                  {/* Q Label */}
                  <span
                    className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-xs font-black transition-all ${
                      isOpen ? 'text-[#0d1f3c]' : 'text-[#c9a227] border border-[#c9a227]/50'
                    }`}
                    style={
                      isOpen ? { background: 'linear-gradient(135deg, #e8c84a, #b8860b)' } : {}
                    }
                  >
                    Q
                  </span>

                  {/* Question Text */}
                  <span
                    className={`flex-1 text-sm sm:text-base font-semibold leading-snug transition-colors ${
                      isOpen ? 'text-white' : 'text-white/80 group-hover:text-white'
                    }`}
                  >
                    {item.question}
                  </span>

                  {/* Arrow */}
                  <span
                    className={`flex-shrink-0 w-6 h-6 flex items-center justify-center transition-transform duration-300 ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-[#c9a227] text-xl"></i>
                  </span>
                </button>

                {/* Answer */}
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-5 sm:px-7 pb-5 sm:pb-6 pt-1">
                    <div className="flex gap-4">
                      {/* A Label */}
                      <span className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-xs font-black text-white/40 border border-white/15">
                        A
                      </span>
                      <p className="text-sm sm:text-base text-white/75 leading-relaxed">
                        {item.answer}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div
          className="mt-10 sm:mt-14 rounded-2xl sm:rounded-3xl p-6 sm:p-10 text-center border border-[#c9a227]/20"
          style={{ background: 'linear-gradient(145deg, rgba(201,162,39,0.08), rgba(13,31,60,0.6))' }}
        >
          <p className="text-base sm:text-xl font-bold text-white mb-2">
            더 궁금한 점이 있으신가요?
          </p>
          <p className="text-sm text-white/55 mb-6 leading-relaxed">
            전문가가 직접 답변해 드립니다. 언제든지 부담 없이 문의하세요.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="tel:010-9879-8375"
              className="flex items-center justify-center gap-2 px-6 sm:px-8 py-3 sm:py-3.5 rounded-full font-bold text-sm sm:text-base text-[#0d1f3c] hover:scale-105 transition-transform cursor-pointer whitespace-nowrap"
              style={{ background: 'linear-gradient(135deg, #e8c84a, #b8860b)' }}
            >
              <i className="ri-phone-line"></i>
              010-9879-8375 전화 문의
            </a>
            <button
              onClick={() => {
                const btn = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
                if (btn) btn.click();
              }}
              className="flex items-center justify-center gap-2 px-6 sm:px-8 py-3 sm:py-3.5 rounded-full font-bold text-sm sm:text-base text-white border border-white/20 hover:border-[#c9a227]/50 hover:text-[#c9a227] transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-chat-smile-2-line"></i>
              AI 챗봇 상담
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
